import { createSelector } from 'reselect'

export const getEmployerVenue$ = createSelector(
  state => state.employerVenues,
  (_, id) => id,
  (employerVenues, id) => employerVenues?.entityMap[id]
)
